import React from 'react'
import { useDispatch } from 'react-redux'
import { MdInfo } from 'react-icons/md'
import ControlButton from '../../../Buttons/ControlButton'

import { setInfoBoxOpen } from '../../../../redux/actions/map.actions'

export default function DownloadPoints() {
  const dispatch = useDispatch()

  const onSetInfoBoxOpen = () => {
    dispatch(setInfoBoxOpen(true))
  }

  return (
    <ControlButton
      icon={MdInfo}
      onClick={onSetInfoBoxOpen}
      customClass="ol-info"
    ></ControlButton>
  )
}
